/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addUserToRole } from '../fn/admin-users/add-user-to-role';
import { AddUserToRole$Params } from '../fn/admin-users/add-user-to-role';
import { AdminUserDtoPage } from '../models/admin-user-dto-page';
import { createUser } from '../fn/admin-users/create-user';
import { CreateUser$Params } from '../fn/admin-users/create-user';
import { deleteUser } from '../fn/admin-users/delete-user';
import { DeleteUser$Params } from '../fn/admin-users/delete-user';
import { disableUser } from '../fn/admin-users/disable-user';
import { DisableUser$Params } from '../fn/admin-users/disable-user';
import { enableUser } from '../fn/admin-users/enable-user';
import { EnableUser$Params } from '../fn/admin-users/enable-user';
import { getUser } from '../fn/admin-users/get-user';
import { GetUser$Params } from '../fn/admin-users/get-user';
import { listUsers } from '../fn/admin-users/list-users';
import { ListUsers$Params } from '../fn/admin-users/list-users';
import { removeUserFromRole } from '../fn/admin-users/remove-user-from-role';
import { RemoveUserFromRole$Params } from '../fn/admin-users/remove-user-from-role';
import { setUserPassword } from '../fn/admin-users/set-user-password';
import { SetUserPassword$Params } from '../fn/admin-users/set-user-password';
import { updateUser } from '../fn/admin-users/update-user';
import { UpdateUser$Params } from '../fn/admin-users/update-user';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class AdminUsersApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listUsers()` */
  static readonly ListUsersPath = '/v0/adminUsers/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUsers$Response(params?: ListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminUserDtoPage>> {
    return listUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUsers(params?: ListUsers$Params, context?: HttpContext): Observable<AdminUserDtoPage> {
    return this.listUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminUserDtoPage>): AdminUserDtoPage => r.body)
    );
  }

  /** Path part for operation `getUser()` */
  static readonly GetUserPath = '/v0/adminUsers/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser$Response(params: GetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return getUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: GetUser$Params, context?: HttpContext): Observable<UserDto> {
    return this.getUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `createUser()` */
  static readonly CreateUserPath = '/v0/adminUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(params: CreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return createUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params: CreateUser$Params, context?: HttpContext): Observable<UserDto> {
    return this.createUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `updateUser()` */
  static readonly UpdateUserPath = '/v0/adminUsers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser$Response(params: UpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUser(params: UpdateUser$Params, context?: HttpContext): Observable<void> {
    return this.updateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteUser()` */
  static readonly DeleteUserPath = '/v0/adminUsers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser$Response(params: DeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(params: DeleteUser$Params, context?: HttpContext): Observable<void> {
    return this.deleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `enableUser()` */
  static readonly EnableUserPath = '/v0/adminUsers/{id}/enable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enableUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  enableUser$Response(params: EnableUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return enableUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enableUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enableUser(params: EnableUser$Params, context?: HttpContext): Observable<void> {
    return this.enableUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `disableUser()` */
  static readonly DisableUserPath = '/v0/adminUsers/{id}/disable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableUser$Response(params: DisableUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return disableUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableUser(params: DisableUser$Params, context?: HttpContext): Observable<void> {
    return this.disableUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setUserPassword()` */
  static readonly SetUserPasswordPath = '/v0/adminUsers/{id}/set-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setUserPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setUserPassword$Response(params: SetUserPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setUserPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setUserPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setUserPassword(params: SetUserPassword$Params, context?: HttpContext): Observable<void> {
    return this.setUserPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addUserToRole()` */
  static readonly AddUserToRolePath = '/v0/adminUsers/{id}/add-role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addUserToRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToRole$Response(params: AddUserToRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addUserToRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addUserToRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addUserToRole(params: AddUserToRole$Params, context?: HttpContext): Observable<void> {
    return this.addUserToRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeUserFromRole()` */
  static readonly RemoveUserFromRolePath = '/v0/adminUsers/{id}/remove-role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeUserFromRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUserFromRole$Response(params: RemoveUserFromRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeUserFromRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeUserFromRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeUserFromRole(params: RemoveUserFromRole$Params, context?: HttpContext): Observable<void> {
    return this.removeUserFromRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
